import React, { useContext } from "react";
import { Paper, Box, Typography } from "@mui/material";
import TextureIcon from "@mui/icons-material/Texture";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { PageContext } from "../../context/PageContext";
export const MapLegend: React.FC = () => {
  const content = useContext(PageContext);

  return (
    <Paper
      sx={{
        position: "fixed",
        width: "fit-content",
        maxWidth: { xs: "11rem", md: "none" },
        flexWrap: "wrap",

        zIndex: 8,
        rowGap: { xs: ".1rem", md: ".5rem" },
        colGap: { xs: ".1rem", md: ".5rem" },
        display: "flex",
        px: { xs: ".25rem", md: "1rem" },
        py: ".5rem",
        m: ".25rem",
        borderRadius: ".5rem",
        bottom: 0,
        backdropFilter: "blur(4px)",
        flexDirection: "column",
        backgroundColor: "#FFFFFF80",
      }}
    >
      <Typography
        sx={{
          fontStyle: "italic",
          fontSize: ".825rem",
          textAlign: "center",
          backgroundColor: "#303030",
          color: "white",
        }}
      >
        Boundary
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <TextureIcon />
        <Typography sx={{ fontSize: ".825rem" }}>
          {"Recommended Boundary Change"}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <DensitySmallIcon sx={{ opacity: 0.8 }} />
        <Typography sx={{ fontSize: ".825rem" }}>
          {"Multiple rights sunset"}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <CheckBoxOutlineBlankIcon />
        <Typography sx={{ fontSize: ".825rem" }}>
          {"Recommended Boundary"}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontStyle: "italic",
          fontSize: ".825rem",
          textAlign: "center",
          backgroundColor: "#303030",
          color: "white",
        }}
      >
        {content.school}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box
          sx={{
            borderRadius: "15px",
            borderColor: "black",
            borderWidth: "0.25px",
            border: "solid",
            backgroundImage:
              "conic-gradient(#ff0 0.2turn, #1fdd6e 0.2turn, #1fdd6e 0.4turn, #f0f 0.4turn, #f0f 0.6turn, #c26c43 0.6turn, #c26c43 0.8turn, #6b24fd 0.8turn, #6b24fd 1turn)",
            width: "20px",
            height: "20px",
          }}
        />
        <Typography sx={{ fontSize: ".825rem" }}>{"DCPS by-right"}</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box
          sx={{
            borderRadius: "100%",
            borderColor: "black",
            borderWidth: "1px",
            border: "solid",
            backgroundColor: "#fff",
            width: "15px",
            height: "15px",
            marginBottom: "5px",
          }}
        />
        <Typography sx={{ fontSize: ".825rem" }}>{"DCPS Citywide"}</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box
          sx={{
            borderRadius: "100%",
            borderColor: "black",
            borderWidth: "0.25px",
            border: "solid",
            backgroundColor: "#000",
            width: "15px",
            height: "15px",
            marginBottom: "5px",
          }}
        />
        <Typography sx={{ fontSize: ".825rem" }}>
          {"Public charter school"}
        </Typography>
      </Box>
    </Paper>
  );
};
